import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { CATEGORIES } from "@/lib/data";

export const SectionHead = ({ eyebrow, title, text, light }) => (
  <div className="max-w-2xl mb-12">
    <p className="font-mono text-xs uppercase tracking-[0.2em] text-[#00b37a] mb-3">{eyebrow}</p>
    <h2 className={`text-2xl sm:text-3xl lg:text-4xl font-bold tracking-tight ${light ? "text-white" : "text-[#05130e]"}`}>{title}</h2>
    {text && <p className={`mt-4 text-base md:text-lg ${light ? "text-slate-300" : "text-slate-600"}`}>{text}</p>}
  </div>
);

export const CategoriesGrid = () => (
  <section id="categorias" className="max-w-[1400px] mx-auto px-5 lg:px-8 py-24" data-testid="categories-section">
    <SectionHead eyebrow="Focus MVP" title="Categorías destacadas de Scrap & Mermas" text="Materiales técnicos no estandarizados que hoy terminan en vertedero y que otra industria necesita." />
    <div className="grid grid-cols-1 md:grid-cols-3 gap-5 md:auto-rows-[240px]">
      {CATEGORIES.map((c, i) => (
        <Link key={c.id} to={`/categorias/${c.id}`} data-testid={`category-card-${c.id}`}
          className={`group relative rounded-2xl overflow-hidden min-h-[220px] ${i === 0 ? "md:col-span-2 md:row-span-2" : ""}`}>
          <img src={c.image} alt={c.name} className="absolute inset-0 w-full h-full object-cover group-hover:scale-105 transition-transform duration-700" />
          <div className="absolute inset-0 bg-gradient-to-t from-[#0a1f18] via-[#0a1f18]/70 to-[#0a1f18]/10" />
          <div className="relative h-full p-6 flex flex-col justify-end">
            <c.icon className="w-7 h-7 text-[#00f2a1] mb-3" />
            <h3 className={`font-bold text-white ${i === 0 ? "text-2xl lg:text-3xl" : "text-lg"}`}>{c.name}</h3>
            <p className="text-sm text-slate-300 mt-1">{c.items}</p>
            <ArrowUpRight className="absolute top-5 right-5 w-6 h-6 text-white/60 group-hover:text-[#00f2a1] group-hover:rotate-45 transition-[color,transform] duration-300" />
          </div>
        </Link>
      ))}
    </div>
  </section>
);
